import axios from 'axios';
import { getApiBaseUrl } from './apiBase';

const TOKEN_KEY = 'bot_admin_jwt';

export function getBotAdminToken() {
  return sessionStorage.getItem(TOKEN_KEY) || '';
}

export function setBotAdminToken(token) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export function createBotAdminClient() {
  const client = axios.create({
    baseURL: getApiBaseUrl(),
    headers: { 'Content-Type': 'application/json' },
  });
  client.interceptors.request.use((config) => {
    const t = getBotAdminToken();
    if (t) {
      config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
  });
  return client;
}
